import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import axios from 'axios';
import "bootstrap-icons/font/bootstrap-icons.css";

import Swal from "sweetalert2";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class profile extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            open: false,
            profile: false,
            customerName: '',
            customerEmail: '',
            customerPhone: '',
            customerAddress: '',
            customerCity: '',
            customerState: '',
            customerZip: '',
            windowHeight: 0,
            categoryList: [],
            customerId: 0,
            customerToken: '',
            reloadKey: 0,
            swalButton: '',

        };
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };


    logout = () => {

        var dbconn = new db();

        dbconn.deleteAll();
        dbconn.deleteAllOrder();
        localStorage.removeItem("remember");

        this.setState({nosessionredirect: true});
    };

    onOpenProfileModal = () => {
        this.setState({profile: true});

    };
    onCloseProfileModal = () => {
        this.setState({profile: false});
    };

    componentWillMount() {
        if (!localStorage.getItem("store_language")) {
            localStorage.setItem("store_language", "en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {

                this.onOpenModal();
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                var url = API_ROOT + '/fetchprofile?customer_id=' + customer_id + '&customer_token=' + customer_token;

                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(customerData => {

                        this.onCloseModal();
                        if (customerData.status == 1) {

                            var custData = customerData.customer_data[0];
                            this.setState({customerName: custData.customer_firstname + " " + custData.customer_lastname});
                            this.setState({customerEmail: i18n.t('email') + ": " + custData.customer_email});
                            this.setState({customerPhone: i18n.t('phone') + ": " + custData.customer_phone});
                            this.setState({customerAddress: custData.customer_address});
                            this.setState({customerCity: custData.customer_city + ", "});
                            this.setState({customerState: custData.customer_state});
                            this.setState({customerZip: custData.customer_zipcode});
                            this.setState({customerId: data[0].customer_id});
                            this.setState({customerToken: data[0].customer_token});
                        }
                    });

                var categroyUrl = API_ROOT + '/fetchcategorylist?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                fetch(categroyUrl)
                    .then(response => {
                        return response.json();
                    })
                    .then(categoryData => {

                        this.onCloseModal();
                        if (categoryData.status == 1) {
                            this.setState({categoryList: categoryData.category_data});

                            var nav = window.$('#nav-main').okayNav();
                            nav.okayNav('recalcNav');
                        }
                    });
            }
        });
    }

    deleteProfile = (e) => {

        this.onCloseProfileModal();
        this.onOpenModal();
        axios.post(API_ROOT + '/deleteprofile', {
            customer_id: this.state.customerId,
            customer_token: this.state.customerToken
        })
            .then(response => {
                this.onCloseModal();

                if (response.data.status == 1) {

                    this.state.swalButton.fire({
                        title: 'Profile deleted successfully.\nNow you will be logged out.',
                        allowOutsideClick: false
                    }).then((result) => {

                        this.logout();

                    });

                } else {

                    this.state.swalButton.fire({
                        title: response.data.message,
                        allowOutsideClick: false
                    }).then((result) => {

                        this.onOpenProfileModal();

                    });


                }
            })
            .catch(error => {
                this.onCloseModal();
                console.log(error);
            });
    }

    componentDidMount() {


        document.title = "My Profile - " + localStorage.getItem("store_name") + " - Tria Commerce";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#resetPwdBtn').click(e => {

            var newPwd = $('#newPwdTxt').val();
            var oldPwd = $('#oldPwdTxt').val();

            var allGood = true;

            if (oldPwd == '' ||
                oldPwd == null ||
                newPwd == '' ||
                newPwd == null) {

                allGood = false;


                this.state.swalButton.fire({
                    title: 'Old password and new password cannot be blank.',
                    allowOutsideClick: false
                });
            }

            if (oldPwd == newPwd) {
                allGood = false;

                this.state.swalButton.fire({
                    title: 'Old password and new password are same. Please enter a different password.',
                    allowOutsideClick: false
                });
            }

            if (newPwd.length < 6) {
                allGood = false;

                this.state.swalButton.fire({
                    title: 'New password must be atleast 6 characters long.',
                    allowOutsideClick: false
                });
            }

            if (allGood) {

                this.onOpenModal();
                axios.post(API_ROOT + '/updatepassword', {
                    customer_id: this.state.customerId,
                    customer_token: this.state.customerToken,
                    old_password: oldPwd,
                    new_password: newPwd
                })
                    .then(response => {
                        this.onCloseModal();

                        if (response.data.status == 1) {

                            this.state.swalButton.fire({
                                title: 'Password updated successfully.',
                                allowOutsideClick: false
                            });
                            this.setState({reloadKey: Math.random()});
                        } else {

                            this.state.swalButton.fire({title: response.data.message, allowOutsideClick: false});

                        }
                    })
                    .catch(error => {
                        this.onCloseModal();
                        console.log(error);
                    });
            }

        });
    }

    render() {

        const {t} = this.props;
        const {open} = this.state;
        const {profile} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        return (

            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/myaccount'}></Link>
                        <h2 className="text-center">{t('profile')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35 bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{this.state.customerName}</h2>
                                </div>
                                <div className="header-content help_content">
                                    <p className="font-family-bold">{this.state.customerEmail} </p>
                                    <p>{this.state.customerPhone}</p>
                                    <p>{this.state.customerAddress}</p>
                                    <p>{this.state.customerCity} {this.state.customerState} {this.state.customerZip}</p>
                                </div>

                                <Link className="link_button"
                                      to={'/profile/edit/' + this.state.customerId}>{t('edit_info')}</Link>
                                <Link to="#" className="link_button"
                                      style={{marginTop: "10px", backgroundColor: "#A42F1E", border: "0"}}
                                      onClick={this.onOpenProfileModal}>{t('delete_profile')}</Link>
                            </div>
                            {/* <div className="bkg_box">
                                <div className="container" style={{width: '100%'}}>
                                    <h3 className="text-center">Reset Password</h3>
                                    <div key={this.state.reloadKey} className="form-box simple-box">
                                        <div className="form-group">
                                            <input className="form-control" type="password" name="oldPwdTxt" id="oldPwdTxt"
                                                   placeholder="Enter Current Password"/>
                                        </div>
                                        <div className="form-group">
                                            <input className="form-control" type="password" name="newPwdTxt" id="newPwdTxt"
                                                   placeholder="Enter New Password (6 characters min.)" minLength='6'/>
                                        </div>
                                        <div className="form-box">
                                            <input className="bkg_black_btn" type="submit" name="resetPwdBtn" id="resetPwdBtn"
                                                   value="Reset Password"/>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                            <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                                   onClose={this.onCloseModal} center>
                                <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                                <p style={{textAlign: 'center'}}>
                                    <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                                </p>
                            </Modal>

                            <Modal classNames={{
                                modal: 'customProfileModal',
                            }} closeOnEsc={true} closeOnOverlayClick={true} showCloseIcon={false} open={profile}
                                   onClose={this.onCloseProfileModal} center>
                                <div className="row">
                                    <div className="modalboxHeader w-100 p-0">&nbsp;</div>
                                </div>

                                <div className="col-md-12">
                                    <div className="sessionAlertBoxBody">
                                        <div className="sessionAlertBoxBodyTop">
                                            <div className="customModalIcon pt-3 infoIcon"><i
                                                className="bi bi-exclamation-lg m-0"></i></div>
                                        </div>
                                        <div className="sessionAlertTitle text-center">Delete Profile?</div>

                                        <p>This action will permanently delete
                                            your profile and all associated data.</p>
                                    </div>


                                    <div className="w-100">


                                        <div className="sessionAlertBoxBodyButtons">
                                            <a href="#"
                                               className="btn-logout" onClick={this.onCloseProfileModal}>Cancel</a>
                                            <a href="#"
                                               className="btn-continue" onClick={this.deleteProfile}>Delete</a>
                                        </div>
                                    </div>
                                </div>

                            </Modal>


                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <div className="clearfix"></div>


            </div>

        );
    }
}

export default withRouter(withTranslation()(profile));


// WEBPACK FOOTER //
// ./src/view_components/profile.js